import React from "react";

export function Resume() {  
    return (
      <main className="resume-container">
        <section className="resume">
          <h1 className="resume-title">Resume</h1>
          <h2 className="section-title">Professional Summary</h2>
          <p className="resume-text">A highly motivated and responsible professional with expertise in AI, ML, and Cloud technologies.</p>
          
          <h2 className="section-title">Technologies</h2>
          <ul className="resume-list">
            <li>AI & ML: Amazon SageMaker, Rekognition, Transcribe, Kendra</li>
            <li>Generative AI & NLP: Amazon Bedrock, GPT, LLaMA, Mistral, Anthropic Claude, VectorDB (OpenSearch, Pinecone, etc.)</li>
            <li>Data & Analytics: Amazon Redshift, QuickSight, Glue, Athena</li>
            <li>Cloud Computing: AWS Lambda, EC2, RDS, DynamoDB, VPC</li>
            <li>Security: AWS IAM, Route53</li>
            <li>Programming: Python, SQL</li>
          </ul>
          
          <h2 className="section-title">Certifications</h2>
          <ul className="resume-list">
            <li>AWS Certified Machine Learning - Specialty</li>
            <li>AWS Certified Machine Learning - Associate</li>
            <li>AWS Certified Data Engineer - Associate</li>
          </ul>
          
          <h2 className="section-title">Work Experience</h2>
          <p className="resume-text"><strong>CloudThat Technologies Private Limited</strong> - Research Associate (2.2 years)</p>
          
         
              <h2 className="section-title">Projects</h2>
              <ul className="resume-list">
                <li><strong>Power BI to Amazon QuickSight Migration:</strong> Migrated dashboards from Power BI to QuickSight.</li>
                <li><strong>AI-Powered Chatbot:</strong> Developed a chatbot for supply chain analysis using Bedrock.</li>
                <li><strong>GenAI-Powered Email Automation:</strong> Created an AI-driven email automation system.</li>
              </ul>
              
              <h2 className="section-title">Additional Skills</h2>
              <ul className="resume-list">
                <li>Data Wrangling & EDA</li>
                <li>Cloud Security & Compliance</li>
                <li>CI/CD Pipelines</li>
              </ul>
        </section>
      </main>
    );
  }
  